module.exports = __webpack_public_path__ + "static/media/avignon_bridge_rhone_1600x1600.09a9dbcb.jpg";